import { render } from "./Fundraising.vue?vue&type=template&id=c779621e&scoped=true"
import script from "./Fundraising.vue?vue&type=script&lang=js"
export * from "./Fundraising.vue?vue&type=script&lang=js"

import "./Fundraising.vue?vue&type=style&index=0&id=c779621e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c779621e"]])

export default __exports__